export default "./dist/stdassets/images/icons/feature-info.png";